import { Component, OnInit } from '@angular/core';
import { ContentfulService } from 'app/contentful.service';
import { SharedHeader } from 'app/custom/shared-header';

@Component({
  selector: 'app-our-clients',
  templateUrl: './our-clients.component.html',
  styleUrls: ['./our-clients.component.scss']
})
export class OurClientsComponent implements OnInit {

  constructor(private contentfulService: ContentfulService) { }
  clientResponse: any;
  clients$ = this.contentfulService.getOurClients();

  ngOnInit(): void {
    this.clients$.subscribe(resp => {
      if (resp) {
        this.clientResponse = resp.fields.clientLogoUrl;
      }
    })
  }

  sharedHeader: SharedHeader = {
    title: "Our Clients",
    subtitle: "Growing together through long-term client partnerships",
    images: ["https://images.squarespace-cdn.com/content/v1/5dd86eda07db674ed859c949/1586052700492-M6FRD5SRGOOA4DYCI5C6/deVol-kitchen-how-design-room-guide.jpg?format=1000w"]
  }

}
